import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'
import { Tabs } from '@components/Tabs/Tabs'
import { Outlet } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'

export const Account = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Account'))
  })

  return (
    <>
      <Tabs
        data={[
          {
            label: 'Organization',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_ACCOUNT}/${RoutePaths.ADMIN_SETTINGS_ACCOUNT_ORGANIZATION}`,
          },
          {
            label: 'Representatives',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_ACCOUNT}/${RoutePaths.ADMIN_SETTINGS_ACCOUNT_REPRESENTATIVES}`,
          },
        ]}
      />
      <Outlet />
    </>
  )
}
